export default __webpack_public_path__ + "static/media/Element3.83efcb6f.png";